// extracted by mini-css-extract-plugin
export var category = "BlogCardSection-module--category--27zl5";
export var nav = "BlogCardSection-module--nav--1kEdr";
export var col2 = "BlogCardSection-module--col2--26GOr";
export var col3 = "BlogCardSection-module--col3--Jhvzn BlogCardSection-module--col2--26GOr";